import React from 'react';

import { useBankrollQuery } from 'api/queries/bankrollQueries';
import { clearBankrollCode } from 'reduxState/currentUserData/userBankroll';
import { staticDispatch } from 'reduxState/store';
import { useSelector } from 'reduxState/storeCore';

import BankrollConnectModal from './BankrollConnectModal';
import { useAutomaticallyApplyBankrollCode } from './bankrollFn';
import BankrollInvalidModal from './BankrollInvalidModal';

export default function BankrollModal({
  bankrollCode,
  onClose,
}: {
  bankrollCode: string;
  onClose: () => void;
}) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  const { data: bankrollData } = useBankrollQuery(bankrollCode);

  const isValid =
    bankrollData?.bankroll &&
    !bankrollData.bankroll.redeemedAt &&
    !bankrollData.bankroll.revokedAt;

  const { applying } = useAutomaticallyApplyBankrollCode(
    bankrollCode,
    bankrollData?.bankroll?.quantity,
    !!isValid
  );

  if (!bankrollData) {
    console.warn('Missing bankroll data');
    return null;
  }

  if (applying) {
    return null;
  }

  const { bankroll } = bankrollData;

  const handleOnClose = () => {
    onClose();
    if (!isValid) {
      // On any error wipe code globally
      staticDispatch(clearBankrollCode());
    }
  };

  if (bankroll === undefined) {
    // Loading
    return null;
  }
  if (!isValid) {
    return (
      <BankrollInvalidModal
        onClose={handleOnClose}
        quantity={bankroll?.quantity}
      />
    );
  }
  if (!walletAddress) {
    return (
      <BankrollConnectModal
        onClose={handleOnClose}
        quantity={bankroll?.quantity}
      />
    );
  }
  return null;
}
